import { render, staticRenderFns } from "./resourceImport.vue?vue&type=template&id=3773225e"
import script from "./resourceImport.vue?vue&type=script&lang=js"
export * from "./resourceImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports